const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.variantCarousel = this.setupVariantCarousel()

    this.updateVariantCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els['quick-buy']?.exists) {
      this.handleQuickBuy = this.handleQuickBuy.bind(this)

      this.listeners.add(
        this.els['quick-buy'].element,
        'click',
        this.handleQuickBuy,
      )
    }

    if (this.els.swatch?.exists) {
      this.handleSwatchEnter = this.handleSwatchEnter.bind(this)
      this.handleSwatchLeave = this.handleSwatchLeave.bind(this)
      this.fetchProductCard = this.fetchProductCard.bind(this)

      this.els.swatch.elements.forEach((swatch) => {
        this.listeners.add(swatch, 'mouseenter', this.handleSwatchEnter)
        this.listeners.add(swatch, 'mouseleave', this.handleSwatchLeave)
        this.listeners.add(swatch, 'click', this.fetchProductCard)
      })
    }

    if (this.els.currentSwatch?.exists) {
      this.listeners.add(
        this.els.currentSwatch.element,
        'click',
        this.handleCurrentSwatchClick.bind(this),
      )
    }
  }

  updateVariantCarousel () {
    if (!this.variantCarousel) return

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.variantCarousel?.update?.()
      })
    })
  }

  setupVariantCarousel () {
    if (!this.els.slides?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  handleSwatchEnter (event) {
    this.replaceMediaFromSwatch(event.currentTarget)
  }

  handleSwatchLeave () {
    this.replaceMediaFromSwatch(this.els.currentSwatch.element)
  }

  replaceMediaFromSwatch (swatch) {
    const templateMedia = swatch.querySelector('template[data-role="media"]')
    const templateMediaHover = swatch.querySelector(
      'template[data-role="media-hover"]',
    )
    if (this.els.media?.exists && templateMedia?.innerHTML?.trim()) {
      this.els.media.element.innerHTML = templateMedia.innerHTML
    }

    if (this.els.mediaHover?.exists) {
      this.els.mediaHover.element.innerHTML =
        templateMediaHover?.innerHTML?.trim() || ''
    }
  }

  async handleQuickBuy () {
    await window.BAO.sectionRenderer
      .fetchSingle(
        'quick-buy',
        this.els['quick-buy'].element.dataset.productUrl,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.sec-QuickBuy')

        this.externalEls['quick-buy'].element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'quick-buy'
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }

  async fetchProductCard (event) {
    try {
      const swatchEl = event.target.closest(this.els.swatch.selector)
      if (!swatchEl) return
      const productUrl = swatchEl.dataset.productUrl
      if (!productUrl) return

      const response = await window.BAO.sectionRenderer.fetchSingle(
        this.productSection,
        productUrl,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)
      const myself = newDOM.querySelector(this.localName)

      /* Update existing colour swatches so positions remain consistent */
      const currentSwatchesEl = this.els.swatches.element
      const newSwatchesEl = myself.querySelector(this.els.swatches.selector)

      if (newSwatchesEl) {
        newSwatchesEl.outerHTML = currentSwatchesEl.outerHTML

        const newSwatchesEls = [
          myself.querySelector(this.els.currentSwatch.selector),
          ...myself.querySelectorAll(this.els.swatch.selector),
        ]

        newSwatchesEls.forEach((newSwatchEl) => {
          const isActive = newSwatchEl.dataset.productUrl === productUrl
          newSwatchEl.classList.toggle('prd-Card_Swatch-active', isActive)

          newSwatchEl.dataset.productCardEl = isActive
            ? 'currentSwatch'
            : 'swatch'
        })
      }

      this.outerHTML = myself.outerHTML
    } catch (error) {
      console.error(error)
    }
  }

  handleCurrentSwatchClick () {
    location.href = this.els.currentSwatch.element.dataset.productUrl
  }

  get productSection () {
    return this.dataset.productSection || 'product-card'
  }
}

customElements.define('product-card', ProductCard, { extends: 'article' })
